const baseUrl = (import.meta.env.VITE_API_URL || "http://localhost:8787").replace(/\/$/, "");
let csrfToken = "";

export class ApiClientError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

export function setCsrfToken(value: string) { csrfToken = value; }

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method || "GET").toUpperCase();
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && csrfToken) headers.set("x-csrf-token", csrfToken);
  const response = await fetch(`${baseUrl}${path}`, { ...init, headers, credentials: "include" });
  const type = response.headers.get("content-type") || "";
  const body = type.includes("application/json") ? await response.json() as { data?: T; error?: { code?: string; message?: string } } : null;
  if (!response.ok) throw new ApiClientError(response.status, body?.error?.code || "request_error", body?.error?.message || "No se ha podido completar la solicitud.");
  return body?.data as T;
}

export function json(method: "POST" | "PUT" | "PATCH" | "DELETE", body?: unknown): RequestInit {
  return { method, ...(body === undefined ? {} : { body: JSON.stringify(body) }) };
}
